import React, { useEffect, useState } from "react";
import "./PageLoader.css";

const PageLoader = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  if (!isLoading) return null;

  return (
    <div className="re-page-loader" id="pageLoader">
      <div className="re-page-loader-inner">
        <div className="fadein-element">
          <img
            alt="Royal Enfield"
            src="https://www.royalenfield.com/content/dam/re-platform-images/pageLoader/pre-loader-01.svg"
          />
          <img
            alt="Royal Enfield"
            src="https://www.royalenfield.com/content/dam/re-platform-images/pageLoader/pre-loader-02.svg"
          />
          <img
            alt="Royal Enfield"
            src="https://www.royalenfield.com/content/dam/re-platform-images/pageLoader/pre-loader-03.svg"
          />
          <img
            alt="Royal Enfield"
            src="https://www.royalenfield.com/content/dam/re-platform-images/pageLoader/pre-loader-04.svg"
          />
          <img
            alt="Royal Enfield"
            src="https://www.royalenfield.com/content/dam/re-platform-images/pageLoader/pre-loader-05.svg"
          />
        </div>
        <div className="loading-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
